import { DateTime } from "luxon";
import { useState, useEffect } from "react";

export function useClock(resolutionMillis = 1000): DateTime {
  const [now, setNow] = useState(DateTime.now());

  useEffect(() => {
    // refresh time every second
    const intervalId = setInterval(
      () => setNow(DateTime.now()),
      resolutionMillis
    );

    return () => clearInterval(intervalId);
  }, [setNow, resolutionMillis]);

  return now;
}
